import { injectable } from "tsyringe";
import { WardConfigurationInjection } from "../../di/WardConfigurationInjection";
import { WardConfigurationListRequestEntity } from "../entities/WardConfigurationListRequestEntity";
import { WardConfigurationFormRequestEntity } from "../entities/WardConfigurationFormRequestEntity";
import { ProvinceConfigurationInjection } from "features/provinceConfiguration/di/ProvinceConfigurationInjection";
import { DistrictConfigurationInjection } from "features/districtConfiguration/di/DistrictConfigurationInjection";

@injectable()
export class WardConfigurationUseCase {
  private repo = WardConfigurationInjection.getRepo();

  private checkParams(params: WardConfigurationListRequestEntity) {
    const { page = 0, limit = 10, ...rest } = params;
    return { page, limit, ...rest };
  }

  async getWardConfigurationList(params: WardConfigurationListRequestEntity) {
    return this.repo.getList(this.checkParams(params));
  }

  async getWardConfigurationDetail(id: string) {
    return this.repo.getDetail({ id });
  }

  async createWardConfiguration(body: WardConfigurationFormRequestEntity) {
    return this.repo.create(body);
  }

  async updateWardConfiguration(body: WardConfigurationFormRequestEntity) {
    return this.repo.update(body);
  }

  async deleteWardConfiguration(id: string) {
    return this.repo.delete({ id });
  }

  async getProvinceList() {
    return ProvinceConfigurationInjection.getRepo().getList({
      page: 0,
      limit: 1000,
      order: "name ASC",
    });
  }

  async getDistrictList(provinceCode: string) {
    return DistrictConfigurationInjection.getRepo().getList({
      page: 0,
      limit: 1000,
      order: "name ASC",
      provinceCode,
    });
  }
}
